export default __webpack_public_path__ + "static/media/Form-GST-REG-06.1c034164.png";